import React, { Suspense } from 'react';
import { Spin } from 'antd';
import { matchPath, Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import asyncComponent from 'util/asyncComponent';

import AuthRoute from 'components/AuthRoute';

import { ROUTES_LIST } from './appRoutes';
import styles from './index.module.less';

const App = () => {
  let { path } = useRouteMatch();
  const location = useLocation();
  const backgroundLocation = location.state?.backgroundLocation;
  const activeOverlayRoute = backgroundLocation
    ? ROUTES_LIST.find(
        route =>
          route.overlay &&
          matchPath(location.pathname, {
            path: `${path}/${route.path}`,
            exact: !!route.exact,
          }),
      )
    : null;
  const isOverlayRoute = Boolean(activeOverlayRoute);
  const pageLocation = isOverlayRoute ? backgroundLocation : location;
  const renderMainRoutes = () => (
    <Switch location={pageLocation}>
      {/* Guarnic routes */}
      <Route path={`${path}/config`} component={asyncComponent(() => import('./config'))} />
      <Redirect exact from={`${path}/user`} to={`${path}/user/profile`} />

      {ROUTES_LIST.map(route => (
        <AuthRoute
          exact={!!route.exact}
          key={route.path}
          path={`${path}/${route.path}`}
          allowedRoles={route.allowedRoles}
          component={route.component}
          onOrgChangeRedirectTo={route.onOrgChangeRedirectTo}
          remoteConfigKey={route.remoteConfigKey}
          writeOnly={!!route.writeOnly}
        />
      ))}

      {process.env.NODE_ENV === 'development' && (
        <Route
          component={asyncComponent(() => import('packages/ui/StoriesRoutes'))}
          path={`${path}/ui/component`}
        />
      )}
      <Redirect to="/error404" />
    </Switch>
  );
  const renderOverlayRoutes = () => (
    <Switch location={location}>
      {ROUTES_LIST.filter(route => route.overlay).map(route => (
        <AuthRoute
          exact={!!route.exact}
          key={route.path}
          path={`${path}/${route.path}`}
          allowedRoles={route.allowedRoles}
          component={route.component}
          onOrgChangeRedirectTo={route.onOrgChangeRedirectTo}
          remoteConfigKey={route.remoteConfigKey}
          writeOnly={!!route.writeOnly}
        />
      ))}
    </Switch>
  );

  return (
    <div className={`gx-main-content-wrapper ${styles.wrapper}`}>
      <Suspense fallback={<Spin />}>
        {renderMainRoutes()}
        {isOverlayRoute && renderOverlayRoutes()}
      </Suspense>
    </div>
  );
};

export default App;
